// Modelo Anamnesis BDD
export default class PatientOfatlmo{
    antecedentes=""
    agudezaVisualOidoDerecho1=""
    agudezaVisualOidoDerecho2=""
    agudezaVisualOidoIzquierdo1=""
    agudezaVisualOidoIzquierdo2=""
    agudezaVisualCercaniaOidoDerecho1=""
    agudezaVisualCercaniaOidoDerecho2=""
    agudezaVisualCercaniaOidoIzquierdo1=""
    agudezaVisualCercaniaOidoIzquierdo2=""
    refraccionOidoIzquierdo=""
    refraccionOidoDerecho=""
    biomicroscopia=""
    presionIntraocularOidoDerecho=""
    presionIntraocularOidoIzquierdo=""
    oftalmoscopia=""
    campimetria=""
    visionDeColores=""
    visionDeProfundidad=""
    diagnosticoRefractivo1=""
    diagnosticoRefractivo1Datos=[]
    diagnosticoRefractivo2=""
    diagnosticoRefractivo2Datos=[]
    diagnosticoPatologico=""
    diagnosticoPatologicoDatos=[]
    tratamiento=""
    conclusiones=""

}



// WEBPACK FOOTER //
// ./src/model/PatientOftalmo.js